import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import Button from './Button.component';
import { ButtonProps } from '../../../interfaces/buttonProps.interface';

const ActionButtonContainer = ({
	children,
	onPress,
	disabled,
	overrideStyle,
	hoverStyle,
}: ButtonProps) => {
	const [hovered, setHovered] = useState(false);

	const buttonStyles = StyleSheet.flatten([
		styles.button,
		overrideStyle,
		hovered && !disabled && (hoverStyle || styles.hoveredButton),
	]);

	return (
		<Button
			buttonStyle={buttonStyles}
			onPress={onPress}
			disabled={disabled}
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
		>
			<View style={styles.actionsContainer}>{children}</View>
		</Button>
	);
};

const styles = StyleSheet.create({
	button: {
		display: 'flex',
		height: 32,
		paddingHorizontal: 16,
		paddingVertical: 6,
		justifyContent: 'center',
		alignItems: 'center',
		gap: 8,
		borderRadius: 8,
	},
	hoveredButton: {
		backgroundColor: '#E3F4FF',
	},
	actionsContainer: {
		display: 'flex',
		flexDirection: 'row',
		height: 32,
		alignItems: 'center',
		gap: 8,
	},
});

export default ActionButtonContainer;
